(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog"]) return;
  try {
    
  class RecipeFilters extends HTMLElement {
    connectedCallback() {
      this.buttons = this.querySelectorAll('[data-recipe-filter]');
      this.cards = this.querySelectorAll('[data-recipe-card]');
      this.buttons.forEach((button) => {
        button.addEventListener('click', () => this.setFilter(button));
      });
    }

    setFilter(button) {
      this.buttons.forEach((b) => b.classList.toggle('is-active', b === button));
      const filter = button.dataset.recipeFilter;
      this.cards.forEach((card) => {
        const tags = card.dataset.recipeTags || '';
        card.hidden = filter !== 'all' && !tags.includes(filter);
      });
    }
  }

  customElements.define('recipe-filters', RecipeFilters);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-cart-dialog]');
      this.closeButton = this.querySelector('[data-cart-close]');
      this.body = this.querySelector('[data-cart-body]');
      this.errorEl = this.querySelector('[data-cart-error]');
      this.cartUrl = this.dataset.cartUrl;
      this.productsUrl = this.dataset.productsUrl;

      this.closeButton.addEventListener('click', () => this.close());
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.close();
      });
      this.dialog.addEventListener('close', () => {
        this.dialog.classList.remove('is-open');
      });

      document.addEventListener('cart:open', () => this.open());
      document.addEventListener('cart:refresh', async () => {
        await this.refreshCart();
        await this.refreshRecommendations();
        this.open();
      });

      document.addEventListener('submit', (event) => {
        const form = event.target;
        if (!(form instanceof HTMLFormElement)) return;
        if (!form.action.includes('/cart/add')) return;
        event.preventDefault();
        this.addToCart(new FormData(form));
      });

      this.body.addEventListener('click', (event) => {
        const decrease = event.target.closest('[data-cart-decrease]');
        const increase = event.target.closest('[data-cart-increase]');
        const remove = event.target.closest('[data-cart-remove]');
        const quickAdd = event.target.closest('[data-cart-quick-add]');

        if (decrease) this.changeLine(decrease, -1);
        else if (increase) this.changeLine(increase, 1);
        else if (remove) this.removeLine(remove.dataset.line);
        else if (quickAdd) this.addVariant(quickAdd.dataset.variantId);
      });

      this.refreshRecommendations();
    }

    open() {
      if (!this.dialog.open) this.dialog.showModal();
      requestAnimationFrame(() => this.dialog.classList.add('is-open'));
    }

    close() {
      this.dialog.classList.remove('is-open');
      setTimeout(() => {
        if (this.dialog.open) this.dialog.close();
      }, 300);
    }

    async addToCart(formData) {
      this.body.classList.add('is-loading');
      this.showError('');
      const response = await fetch('/cart/add.js', { method: 'POST', body: formData, headers: { Accept: 'application/json' } });
      if (!response.ok) {
        const data = await response.json().catch(() => null);
        this.showError((data && (data.description || data.message)) || this.dataset.errorGeneric);
        this.body.classList.remove('is-loading');
        this.open();
        return;
      }
      await this.refreshCart();
      await this.refreshRecommendations();
      this.body.classList.remove('is-loading');
      this.open();
    }

    showError(message) {
      if (!this.errorEl) return;
      this.errorEl.textContent = message || '';
      this.errorEl.hidden = !message;
    }

    addVariant(variantId) {
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');
      this.addToCart(formData);
    }

    async changeLine(button, delta) {
      const line = button.dataset.line;
      const qtyEl = button.closest('.cart-drawer__item-quantity').querySelector('[data-cart-qty]');
      const nextQty = Math.max(0, parseInt(qtyEl.textContent, 10) + delta);
      this.body.classList.add('is-loading');
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: nextQty }),
      });
      await this.refreshCart();
      await this.refreshRecommendations();
      this.body.classList.remove('is-loading');
    }

    async removeLine(line) {
      this.body.classList.add('is-loading');
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: 0 }),
      });
      await this.refreshCart();
      this.body.classList.remove('is-loading');
    }

    async refreshCart() {
      const response = await fetch(`${this.cartUrl}?section_id=cart-drawer`);
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const freshBody = doc.querySelector('[data-cart-body]');
      if (!freshBody) return;
      this.body.innerHTML = freshBody.innerHTML;
      this.body.dataset.primaryProductHandle = freshBody.dataset.primaryProductHandle || '';
      const countEl = this.body.querySelector('[data-cart-count-value]');
      const count = countEl ? parseInt(countEl.textContent, 10) : 0;
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { count } }));
    }

    async refreshRecommendations() {
      const container = this.body.querySelector('[data-cart-recommendations]');
      const handle = this.body.dataset.primaryProductHandle;
      if (!container) return;
      if (!handle) {
        container.innerHTML = '';
        return;
      }
      const url = `${this.productsUrl}/${handle}?section_id=cart-drawer`;
      const response = await fetch(url);
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-cart-recommendations-response]');
      container.innerHTML = fresh ? fresh.innerHTML : '';
    }
  }

  customElements.define('cart-drawer', CartDrawer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.querySelectorAll('[data-distribution-note]').forEach((noteInput) => {
    const form = noteInput.closest('form');
    if (!form) return;
    form.addEventListener('submit', () => {
      const company = form.querySelector('[data-distribution-company]');
      const state = form.querySelector('[data-distribution-state]');
      const parts = [];
      if (company && company.value) parts.push(`Empresa: ${company.value}`);
      if (state && state.value) parts.push(`Estado a distribuir: ${state.value}`);
      noteInput.value = parts.join(' | ');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderMenu extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('[data-menu-toggle]');
      this.dialog = this.querySelector('[data-menu-dialog]');
      this.closeButton = this.querySelector('[data-menu-close]');
      this.header = this.querySelector('.header');

      this.toggle.addEventListener('click', () => this.open());
      this.closeButton.addEventListener('click', () => this.close());
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.close();
      });
      this.dialog.addEventListener('close', () => {
        this.toggle.setAttribute('aria-expanded', 'false');
      });

      this.querySelectorAll('.header__panel-summary').forEach((summary) => {
        const details = summary.closest('details');
        const link = summary.querySelector('.header__panel-summary-link');
        // Summary's native click-to-toggle would otherwise fire for any
        // click landing in its box — only suppress it when the tap isn't
        // on the real "Comprar" link, so the link keeps navigating
        // normally and the toggle button drives open/close explicitly.
        summary.addEventListener('click', (event) => {
          if (!link.contains(event.target)) event.preventDefault();
        });
        summary.querySelector('.header__panel-summary-toggle').addEventListener('click', () => {
          details.open = !details.open;
        });
      });

      this.headerOffset = null;
      this.updatePinned = this.updatePinned.bind(this);
      this.updatePinned();
      window.addEventListener('scroll', this.updatePinned, { passive: true });
      window.addEventListener('resize', () => {
        this.headerOffset = null;
        this.updatePinned();
      });

      this.cartIcon = this.querySelector('[data-cart-icon]');
      this.cartCount = this.querySelector('[data-cart-icon-count]');
      if (this.cartIcon) {
        this.cartIcon.addEventListener('click', (event) => {
          event.preventDefault();
          document.dispatchEvent(new CustomEvent('cart:open'));
        });
      }
      document.addEventListener('cart:updated', (event) => {
        if (!this.cartCount) return;
        const count = event.detail.count;
        this.cartCount.textContent = count;
        this.cartCount.hidden = count === 0;
      });
    }

    updatePinned() {
      if (this.headerOffset === null) {
        const wasPinned = this.header.classList.contains('header--pinned');
        if (wasPinned) this.header.classList.remove('header--pinned');
        this.headerOffset = this.header.getBoundingClientRect().top + window.scrollY;
        if (wasPinned) this.header.classList.add('header--pinned');
      }
      this.header.classList.toggle('header--pinned', window.scrollY > this.headerOffset);
    }

    open() {
      this.dialog.showModal();
      this.toggle.setAttribute('aria-expanded', 'true');
    }

    close() {
      this.dialog.close();
    }
  }

  customElements.define('header-menu', HeaderMenu);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-spotlight"]) return;
  try {
    
  class ProductSpotlight extends HTMLElement {
    connectedCallback() {
      this.tabs = this.querySelectorAll('[data-spotlight-tab]');
      this.panels = this.querySelectorAll('[data-spotlight-panel]');

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.show(tab.dataset.spotlightTab));
      });

      const initialPanel = this.querySelector('[data-spotlight-panel]:not([hidden])') || this.panels[0];
      if (initialPanel) {
        this.style.setProperty('--spotlight-accent', initialPanel.dataset.spotlightAccent);
      }
    }

    show(index) {
      this.tabs.forEach((tab) => {
        tab.classList.toggle('is-active', tab.dataset.spotlightTab === index);
        tab.setAttribute('aria-pressed', tab.dataset.spotlightTab === index);
      });
      this.panels.forEach((panel) => {
        panel.hidden = panel.dataset.spotlightPanel !== index;
        if (panel.dataset.spotlightPanel === index) {
          this.style.setProperty('--spotlight-accent', panel.dataset.spotlightAccent);
        }
      });
    }
  }

  customElements.define('product-spotlight', ProductSpotlight);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.images = this.querySelectorAll('[data-gallery-image]');
      this.thumbs = this.querySelectorAll('[data-gallery-thumb]');
      this.options = this.querySelectorAll('.product__option');
      this.ctaElement = this.querySelector('[data-cta]');
      this.variantInput = this.querySelector('[data-variant-input]');
      this.quantityInput = this.querySelector('[data-quantity-input]');

      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => this.showImage(thumb.dataset.galleryThumb));
      });

      this.options.forEach((option) => {
        option.addEventListener('click', () => this.selectVariant(option));
      });

      const decrease = this.querySelector('[data-quantity-decrease]');
      const increase = this.querySelector('[data-quantity-increase]');
      if (decrease && increase && this.quantityInput) {
        decrease.addEventListener('click', () => this.stepQuantity(-1));
        increase.addEventListener('click', () => this.stepQuantity(1));
      }
    }

    stepQuantity(delta) {
      const next = Math.max(1, parseInt(this.quantityInput.value || '1', 10) + delta);
      this.quantityInput.value = next;
    }

    showImage(index) {
      this.images.forEach((image) => {
        image.hidden = image.dataset.galleryImage !== index;
      });
      this.thumbs.forEach((thumb) => {
        thumb.classList.toggle('is-active', thumb.dataset.galleryThumb === index);
      });
    }

    selectVariant(selectedOption) {
      this.options.forEach((option) => {
        const isSelected = option === selectedOption;
        option.classList.toggle('is-selected', isSelected);
        option.setAttribute('aria-pressed', isSelected);
      });

      this.variantInput.value = selectedOption.dataset.variantId;
      this.ctaElement.textContent = selectedOption.dataset.ctaLabel;
    }
  }

  customElements.define('product-gallery', ProductGallery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-all"] && !Shopify.designMode) return;
  try {
    
  class ShopAllFilters extends HTMLElement {
    connectedCallback() {
      this.buttons = this.querySelectorAll('[data-filter]');
      this.groups = this.querySelectorAll('[data-filter-group]');

      this.buttons.forEach((button) => {
        button.addEventListener('click', () => this.filter(button.dataset.filter));
      });
    }

    filter(value) {
      this.buttons.forEach((button) => {
        const isActive = button.dataset.filter === value;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive);
      });

      this.groups.forEach((group) => {
        const matches = value === 'all' || group.dataset.filterGroup === value;
        group.hidden = !matches;
      });
    }
  }

  customElements.define('shop-all-filters', ShopAllFilters);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-aperitivo"] && !Shopify.designMode) return;
  try {
    
  class ShopCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-carousel-track]');
      const section = this.closest('.shop-the-aperitivo');

      section?.querySelectorAll('[data-carousel-prev]').forEach((button) => {
        button.addEventListener('click', () => this.scrollByCard(-1));
      });
      section?.querySelectorAll('[data-carousel-next]').forEach((button) => {
        button.addEventListener('click', () => this.scrollByCard(1));
      });
    }

    scrollByCard(direction) {
      const slide = this.track.querySelector('.shop-the-aperitivo__slide');
      if (!slide) return;

      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const distance = (slide.getBoundingClientRect().width + gap) * direction;

      this.track.scrollBy({ left: distance, behavior: 'smooth' });
    }
  }

  customElements.define('shop-carousel', ShopCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscribe"]) return;
  try {
    
  class PlanSelector extends HTMLElement {
    connectedCallback() {
      this.buttons = this.querySelectorAll('[data-plan-option]');
      this.panels = document.querySelectorAll('[data-plan-panel]');

      this.buttons.forEach((button) => {
        button.addEventListener('click', () => this.select(button.dataset.planOption));
      });
    }

    select(plan) {
      this.buttons.forEach((button) => {
        button.classList.toggle('is-active', button.dataset.planOption === plan);
      });
      this.panels.forEach((panel) => {
        panel.hidden = panel.dataset.planPanel !== plan;
      });
    }
  }

  customElements.define('plan-selector', PlanSelector);

  class ProBuilder extends HTMLElement {
    connectedCallback() {
      this.boxSize = 2;
      this.items = [];

      this.sizeButtons = this.querySelectorAll('[data-pro-size-option]');
      this.bottles = this.querySelectorAll('[data-bottle]');
      this.slotsEl = this.querySelector('[data-pro-slots]');
      this.countEl = this.querySelector('[data-pro-count]');
      this.sizeLabelEl = this.querySelector('[data-pro-size-label]');
      this.savingsEl = this.querySelector('[data-pro-savings]');
      this.savingsAmountEl = this.querySelector('[data-pro-savings-amount]');
      this.savingsPercentEl = this.querySelector('[data-pro-savings-percent]');
      this.priceOnceEl = this.querySelector('[data-pro-price-once]');
      this.priceSubscribeEl = this.querySelector('[data-pro-price-subscribe]');
      this.purchaseTypeInputs = this.querySelectorAll('[data-pro-purchase-type]');
      this.frequencySelect = this.querySelector('[data-pro-frequency-select]');
      this.ctaButton = this.querySelector('[data-pro-add-to-cart]');

      this.sizeButtons.forEach((button) => {
        button.addEventListener('click', () => this.setBoxSize(button));
      });
      this.bottles.forEach((bottle) => {
        bottle.querySelector('[data-bottle-add]').addEventListener('click', () => this.addBottle(bottle));
      });
      this.purchaseTypeInputs.forEach((input) => {
        input.addEventListener('change', () => this.render());
      });
      this.ctaButton.addEventListener('click', () => this.addToCart());

      this.setBoxSize(this.sizeButtons[0]);
    }

    formatMoney(cents) {
      const amount = (cents / 100).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return `$ ${amount}`;
    }

    setBoxSize(button) {
      this.sizeButtons.forEach((b) => b.classList.toggle('is-active', b === button));
      this.boxSize = parseInt(button.dataset.proSizeOption, 10);
      this.items = [];
      this.sizeLabelEl.textContent = this.boxSize;
      this.render();
    }

    addBottle(bottle) {
      if (this.items.length >= this.boxSize) return;
      this.items.push({
        name: bottle.dataset.name,
        price: parseInt(bottle.dataset.price, 10),
        variantId: bottle.dataset.variantId,
      });
      this.render();
    }

    removeItem(index) {
      this.items.splice(index, 1);
      this.render();
    }

    render() {
      this.slotsEl.innerHTML = '';
      for (let i = 0; i < this.boxSize; i += 1) {
        const slot = document.createElement('button');
        slot.type = 'button';
        slot.className = 'subscribe-box__slot';
        const item = this.items[i];
        if (item) {
          slot.classList.add('is-filled');
          slot.textContent = item.name;
          slot.addEventListener('click', () => this.removeItem(i));
        } else {
          slot.textContent = '+';
          slot.disabled = true;
        }
        this.slotsEl.appendChild(slot);
      }

      this.countEl.textContent = this.items.length;

      const individualTotal = this.items.reduce((sum, item) => sum + item.price, 0);
      const oncePriceCents = Math.round(individualTotal * 0.8);
      const subscribePriceCents = Math.round(individualTotal * 0.8 * 0.9);
      const savings = individualTotal - oncePriceCents;

      if (this.items.length === this.boxSize && savings > 0) {
        this.savingsEl.hidden = false;
        this.savingsAmountEl.textContent = this.formatMoney(savings);
        this.savingsPercentEl.textContent = Math.round((savings / individualTotal) * 100);
      } else {
        this.savingsEl.hidden = true;
      }

      this.priceOnceEl.textContent = this.formatMoney(oncePriceCents);
      this.priceSubscribeEl.textContent = this.formatMoney(subscribePriceCents);

      const isSubscribe = this.querySelector('[data-pro-purchase-type]:checked').value === 'subscribe';
      this.frequencySelect.hidden = !isSubscribe;

      const isComplete = this.items.length === this.boxSize;
      this.ctaButton.disabled = !isComplete;
      this.ctaButton.textContent = isComplete
        ? this.ctaButton.dataset.labelReady
        : this.ctaButton.dataset.labelIncomplete;
    }

    async addToCart() {
      const isSubscribe = this.querySelector('[data-pro-purchase-type]:checked').value === 'subscribe';

      const grouped = {};
      this.items.forEach((item) => {
        const numericId = item.variantId.split('/').pop();
        grouped[numericId] = (grouped[numericId] || 0) + 1;
      });

      const payload = {
        items: Object.entries(grouped).map(([id, quantity]) => {
          const line = { id: Number(id), quantity };
          if (isSubscribe) line.selling_plan = Number(this.frequencySelect.value);
          return line;
        }),
      };

      this.ctaButton.disabled = true;
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      document.dispatchEvent(new CustomEvent('cart:refresh'));

      this.items = [];
      this.render();
    }
  }

  customElements.define('pro-builder', ProBuilder);

  class SubscribeBuilder extends HTMLElement {
    connectedCallback() {
      this.boxSize = 6;
      this.items = [];

      this.filterButtons = this.querySelectorAll('[data-filter]');
      this.sizeButtons = this.querySelectorAll('[data-box-size-option]');
      this.bottles = this.querySelectorAll('[data-bottle]');
      this.slotsEl = this.querySelector('[data-box-slots]');
      this.countEl = this.querySelector('[data-box-count]');
      this.sizeLabelEl = this.querySelector('[data-box-size-label]');
      this.savingsEl = this.querySelector('[data-box-savings]');
      this.savingsAmountEl = this.querySelector('[data-savings-amount]');
      this.savingsPercentEl = this.querySelector('[data-savings-percent]');
      this.priceOnceEl = this.querySelector('[data-price-once]');
      this.priceSubscribeEl = this.querySelector('[data-price-subscribe]');
      this.purchaseTypeInputs = this.querySelectorAll('[data-purchase-type]');
      this.frequencySelect = this.querySelector('[data-frequency-select]');
      this.ctaButton = this.querySelector('[data-box-add-to-cart]');

      this.filterButtons.forEach((button) => {
        button.addEventListener('click', () => this.setFilter(button));
      });
      this.sizeButtons.forEach((button) => {
        button.addEventListener('click', () => this.setBoxSize(button));
      });
      this.bottles.forEach((bottle) => {
        bottle.querySelector('[data-bottle-add]').addEventListener('click', () => this.addBottle(bottle));
      });
      this.purchaseTypeInputs.forEach((input) => {
        input.addEventListener('change', () => this.render());
      });
      this.ctaButton.addEventListener('click', () => this.addToCart());

      this.setBoxSize(this.sizeButtons[0]);
    }

    formatMoney(cents) {
      const amount = (cents / 100).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return `$ ${amount}`;
    }

    setFilter(button) {
      this.filterButtons.forEach((b) => b.classList.toggle('is-active', b === button));
      const filter = button.dataset.filter;
      this.bottles.forEach((bottle) => {
        const categories = bottle.dataset.category.split(' ');
        bottle.hidden = !categories.includes(filter);
      });
    }

    setBoxSize(button) {
      this.sizeButtons.forEach((b) => b.classList.toggle('is-active', b === button));
      this.boxSize = parseInt(button.dataset.boxSizeOption, 10);
      this.boxPriceCents = parseInt(button.dataset.boxPrice, 10);
      this.items = [];
      this.sizeLabelEl.textContent = this.boxSize;
      this.render();
    }

    addBottle(bottle) {
      if (this.items.length >= this.boxSize) return;
      this.items.push({
        name: bottle.dataset.name,
        price: parseInt(bottle.dataset.price, 10),
      });
      this.render();
    }

    removeItem(index) {
      this.items.splice(index, 1);
      this.render();
    }

    render() {
      this.slotsEl.innerHTML = '';
      for (let i = 0; i < this.boxSize; i += 1) {
        const slot = document.createElement('button');
        slot.type = 'button';
        slot.className = 'subscribe-box__slot';
        const item = this.items[i];
        if (item) {
          slot.classList.add('is-filled');
          slot.textContent = item.name;
          slot.addEventListener('click', () => this.removeItem(i));
        } else {
          slot.textContent = '+';
          slot.disabled = true;
        }
        this.slotsEl.appendChild(slot);
      }

      this.countEl.textContent = this.items.length;

      const individualTotal = this.items.reduce((sum, item) => sum + item.price, 0);
      const savings = individualTotal - this.boxPriceCents;
      if (this.items.length === this.boxSize && savings > 0) {
        this.savingsEl.hidden = false;
        this.savingsAmountEl.textContent = this.formatMoney(savings);
        this.savingsPercentEl.textContent = Math.round((savings / individualTotal) * 100);
      } else {
        this.savingsEl.hidden = true;
      }

      this.priceOnceEl.textContent = this.formatMoney(this.boxPriceCents);
      this.priceSubscribeEl.textContent = this.formatMoney(Math.round(this.boxPriceCents * 0.9));

      const isSubscribe = this.querySelector('[data-purchase-type]:checked').value === 'subscribe';
      this.frequencySelect.hidden = !isSubscribe;

      const isComplete = this.items.length === this.boxSize;
      this.ctaButton.disabled = !isComplete;
      this.ctaButton.textContent = isComplete
        ? this.ctaButton.dataset.labelReady
        : this.ctaButton.dataset.labelIncomplete;
    }

    async addToCart() {
      const isSubscribe = this.querySelector('[data-purchase-type]:checked').value === 'subscribe';
      const variantId = this.boxSize === 6
        ? this.ctaButton.dataset.box6VariantId
        : this.ctaButton.dataset.box12VariantId;
      const variantNumericId = variantId.split('/').pop();

      const propertiesSummary = this.items.map((item) => item.name).join(', ');

      const payload = {
        items: [
          {
            id: Number(variantNumericId),
            quantity: 1,
            properties: { Botellas: propertiesSummary },
          },
        ],
      };
      if (isSubscribe) {
        payload.items[0].selling_plan = Number(this.frequencySelect.value);
      }

      this.ctaButton.disabled = true;
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      document.dispatchEvent(new CustomEvent('cart:refresh'));

      this.items = [];
      this.render();
    }
  }

  customElements.define('subscribe-builder', SubscribeBuilder);

  } catch(e) { console.error(e); }
})();
})();
